var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"content",staticClass:"preview-text ellipsis",staticStyle:{"white-space":"pre-line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }